class ModalNewsletter extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.date = new Date(this.getAttribute("data-countdown-value"));

        this.initElements();
        this.initEvents();
    }

    initElements() {
        this.daysWrapper = this.querySelector("[data-countdown-days]");
        this.hoursWrapper = this.querySelector("[data-countdown-hours]");
        this.minutesWrapper = this.querySelector("[data-countdown-minutes]");
        this.secondsWrapper = this.querySelector("[data-countdown-seconds]");
    }

    startTimer() {
        this.now = new Date();
        this.deff = (+this.date - +this.now) / 1000;

        this.days = Math.floor(+this.deff / 60 / 60 / 24);
        this.hours = Math.floor((+this.deff / 60 / 60) % 24);
        this.minutes = Math.floor((+this.deff / 60) % 60);
        this.seconds = Math.floor(+this.deff % 60);

        this.daysWrapper.innerHTML = +this.days;
        this.hoursWrapper.innerHTML = +this.hours;
        this.minutesWrapper.innerHTML = +this.minutes;
        this.secondsWrapper.innerHTML = +this.seconds;
    }

    initEvents() {
        this.interval = setInterval(() => {
            this.startTimer();
        }, 1000);
    }
}

if(!window.customElements.get("modal-newsletter")) {
    window.customElements.define("modal-newsletter", ModalNewsletter);
}